<script>
export default {
  props: ["color"],
};
</script>

<template>
    <svg fill="none" height="37" viewBox="0 0 23 37" width="23" xmlns="http://www.w3.org/2000/svg"><g :fill="color"><path d="m15.1635 30.2886v-15.7052h-6.69773v15.7052h-7.83653v6.7114h22.37076v-6.7114z"/><path d="m15.1635.00128945c0 8.39157055-6.7891 15.19461055-15.1635 15.19461055v-6.7115c4.67618 0 8.46577-3.79864 8.46577-8.4844h6.69773z"/></g></svg>
</template>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/participant-numbers/1.vue